import React, { useState } from "react";
import { Card, CardBody, Col, Container, Input, Row } from "reactstrap";

import signInImage from "../../assets/images/auth/sign-in.png";
import { Form } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import FloatingInput from '../../components/Input';
import { post } from "../../utils/apiUtil";

const SignIn = () => {
    document.title = "Sign In - Matrix Executive Search Group";
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState({
        emailAddress: '',
        password: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            const response = await post('/login', formData);
            if (response?.data?.token) {
                localStorage.setItem('token', response?.data?.token);
            } else {
                throw new Error("Invalid response from server.");
            }
            navigate('/');
        } catch (error) {
            alert(error?.response?.data || "Something went wrong.");
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <React.Fragment>
            <div>
                <div className="main-content">
                    <div className="page-content">
                        <section className="bg-auth" style={{ minHeight: "100vh" }}>
                            <Container>
                                <Row className="justify-content-center">
                                    <Col xl={10} lg={12}>
                                        <Card className="auth-box">
                                            <Row className="g-0">
                                                <Col lg={6} className="text-center">
                                                    <CardBody className="p-4">
                                                        {/* <Link to="/">
                                                            <img
                                                                src={lightLogo}
                                                                alt=""
                                                                className="logo-light"
                                                            />
                                                            <img
                                                                src={darkLogo}
                                                                alt=""
                                                                className="logo-dark"
                                                            />
                                                        </Link> */}
                                                        <div className="mt-5">
                                                            <img
                                                                src={signInImage}
                                                                alt=""
                                                                className="img-fluid"
                                                                draggable={false}
                                                                style={{ maxWidth: "310px", height: "auto" }}
                                                            />
                                                        </div>
                                                    </CardBody>
                                                </Col>
                                                <Col lg={6}>
                                                    <CardBody className="auth-content p-5 h-100 text-white">
                                                        <div className="w-100">
                                                            <div className="text-center mb-4">
                                                                <h5>Welcome</h5>
                                                                <p className="text-white-70">
                                                                    Sign in to continue to.
                                                                </p>
                                                            </div>
                                                            <Form action="/" className="auth-form" onSubmit={handleSubmit}>
                                                                <FloatingInput
                                                                    name="emailAddress"
                                                                    label="Enter your email address"
                                                                    type="email"
                                                                    bgType="dark"
                                                                    onChange={handleChange}
                                                                    required
                                                                />

                                                                <FloatingInput
                                                                    name="password"
                                                                    label="Enter your password"
                                                                    type="password"
                                                                    bgType="dark"
                                                                    onChange={handleChange}
                                                                    required
                                                                />

                                                                <div className="mb-4">
                                                                    <div className="form-check">
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="checkbox"
                                                                            id="flexCheckDefault"
                                                                        />
                                                                        <Link to="/resetpassword" className="float-end text-white">
                                                                            Forgot Password?
                                                                        </Link>
                                                                        <label className="form-check-label" htmlFor="flexCheckDefault">
                                                                            Remember me
                                                                        </label>
                                                                    </div>
                                                                </div>

                                                                <div className="text-center">
                                                                    <button
                                                                        type="submit"
                                                                        className="btn btn-white btn-hover w-100"
                                                                        disabled={isLoading}
                                                                    >
                                                                        {isLoading ? 'Please wait.' : 'Sign In'}
                                                                    </button>
                                                                </div>
                                                            </Form>
                                                            <div className="mt-4 text-center">
                                                                <p className="mb-0 fs-14">
                                                                    Don't have an account ?{" "}
                                                                    <Link
                                                                        to="/signup"
                                                                        className="fw-medium text-white text-decoration-underline"
                                                                    >
                                                                        {" "}
                                                                        Sign Up{" "}
                                                                    </Link>
                                                                </p>
                                                            </div>
                                                            <div className="mt-1 text-center">
                                                                <p className="mb-0 fs-13">
                                                                    Back to {" "}
                                                                    <Link
                                                                        to="/"
                                                                        className="fw-medium text-white text-decoration-underline"
                                                                    >
                                                                        {" "}
                                                                        Home
                                                                        {" "}
                                                                    </Link>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </CardBody>
                                                </Col>
                                            </Row>
                                        </Card>
                                    </Col>
                                </Row>
                            </Container>
                        </section>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default SignIn;
